import { element } from 'protractor';
import { Component, OnInit } from '@angular/core';
import { GamesService } from '../Services/games.service';

@Component({
  selector: 'app-approve',
  templateUrl: './approve.component.html',
  styleUrls: ['./approve.component.css']
})
export class ApproveComponent implements OnInit {
 games_list:Array <any>;
 action_text="activate";
  constructor( private Games :GamesService) {

    this.Games.GamesRequest().subscribe(next=>{
      console.log(next);
      this.games_list=next['games_list'];
    }),
    error=>{
      console.log(error);
      
    }
   }

  ngOnInit() {
  }
  active(id){
 var gamew;
   gamew= this.games_list.filter(game=>game.game_id==id)



  if(gamew[0].game_status) {


    this.Games.disactiveGame(id).subscribe(next=>{

    var  gamey:any;

this.games_list.forEach(element=>{
  if(element.game_id==id){
    element.game_status=false;
  }
})
     
      
     
        
      

    })



  }

    else {
    this.Games.activeGame(id).subscribe(next=>{
     
    var  gamey:any;

this.games_list.forEach(element=>{
  if(element.game_id==id){
    element.game_status=true;
  }
})
     
      
    
        
      

    })
  }

  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/approve/approve.component.ts